import { useMemo } from "react";
import { Image as IImage } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import {
  Constrainer,
  HorizontalSpacer,
  VerticalSpacer,
} from "../../internal-components/Layout.js";
import { Figure, Wrapper } from "./styles.js";

export interface Props {
  images?: {
    image?: IImage;
    captionPosition?: "left" | "right";
  }[];
  largerCaption?: boolean;
  largerImage?: boolean;
  noRoundCorners?: boolean;
}

export const Image: React.FunctionComponent<Props> = ({
  images = [],
  largerCaption,
  largerImage,
  noRoundCorners,
}) => {
  if (images.length === 0) {
    return null;
  }

  const largeImage = largerImage && images.length === 1 && !largerCaption;
  const hasTwoImages = images.length > 1;
  const width = useMemo(() => {
    if (largeImage || largerCaption || hasTwoImages) {
      return "medium";
    }
    return "small";
  }, [largerCaption, hasTwoImages, largeImage]);

  return (
    <VerticalSpacer>
      <HorizontalSpacer>
        <Constrainer $width={width}>
          <Wrapper $columns={hasTwoImages ? 2 : 1} $largerImage={largerImage}>
            {images.map((i, k) => {
              if (!i.image) {
                return null;
              }

              return (
                <Figure
                  key={k}
                  $captionPosition={
                    i.captionPosition
                      ? i.captionPosition
                      : hasTwoImages
                      ? "right"
                      : "left"
                  }
                  $largerCaption={largerCaption}
                  $largeImage={largeImage}
                  $noRoundCorners={noRoundCorners}
                >
                  <img
                    src={transformImageUrl(i.image, { width: 1200 })}
                    alt={i.image.altText}
                  />
                  {i.image.caption && (
                    <figcaption className={largerCaption ? "h3" : undefined}>
                      {i.image.caption}
                    </figcaption>
                  )}
                </Figure>
              );
            })}
          </Wrapper>
        </Constrainer>
      </HorizontalSpacer>
    </VerticalSpacer>
  );
};
